import * as React from "react";

function Compensation(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 29 29" fill="none" {...props}>
      <path
        d="M16.75 22.083c5.89 0 10.666-4.775 10.666-10.666S22.641.75 16.75.75 6.083 5.526 6.083 11.417c0 5.89 4.776 10.666 10.667 10.666zM2.292 12.75a9.482 9.482 0 0013.125 13.125"
        stroke="#333"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M17.48 6.084a.75.75 0 00-1.5 0h1.5zm-1.5 10.667a.75.75 0 101.5 0h-1.5zm2.44-7.557a.75.75 0 101.47-.294l-.735.147-.735.147zm-3.604 4.434a.75.75 0 10-1.466.32l.733-.16.733-.16zm1.914-2.364v-.75c-.83 0-1.24-.157-1.436-.313-.157-.125-.277-.332-.277-.78h-1.5c0 .738.215 1.453.842 1.953.588.469 1.41.64 2.37.64v-.75zM14.267 9.42h.75c0-.681.668-1.4 1.713-1.4v-1.5c-1.676 0-3.213 1.206-3.213 2.9h.75zm5.15 3.995h-.75c0 .543-.198.845-.472 1.04-.313.222-.81.36-1.465.36v1.5c.828 0 1.674-.168 2.334-.637.698-.497 1.102-1.27 1.102-2.263h-.75zm-2.687-2.151v.75c.837 0 1.305.15 1.556.343.208.16.38.44.38 1.058h1.5c0-.92-.275-1.714-.963-2.245-.645-.498-1.52-.656-2.473-.656v.75zm0-3.995h.75V6.084h-1.5v1.185h.75zm0 8.297h-.75v1.185h1.5v-1.185h-.75zm0-8.297v.75c.922 0 1.57.576 1.69 1.175l.735-.147.736-.147c-.285-1.42-1.655-2.38-3.161-2.38v.75zm0 8.297v-.75c-1.082 0-1.79-.62-1.914-1.188l-.733.16-.733.16c.317 1.45 1.811 2.368 3.38 2.368v-.75z"
        fill="#333"
      />
    </svg>
  );
}

export default Compensation;
